import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, LogIn, IPagination, IPaginateResult, Order, Coupon, ChangePassword, InitChangePassword } from 'src/app/interfaces';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    register(payload: User) {
        return this.http.post<{ accessToken: string }>(`${this.path}/user/register`, payload);
    }

    login(payload: LogIn) {
        return this.http.post<{ accessToken: string }>(`${this.path}/user/auth/login`, payload);
    }

    logout(token: string) {
        return this.http.post(`${this.path}/user/auth/logout`, token);
    }
    syncAll() {
        return this.http.post(`${this.path}/products/sync-all`, {});
    }
    syncUpdates() {
        return this.http.post(`${this.path}/products/sync-all-updated`, {});
    }
    syncLandingPage() {
        return this.http.post(`${this.path}/landing-page/sync-from-woocommerce`, {});
    }
    activateLandingPage() {
        return this.http.patch(`${this.path}/landing-page/activate`, {});
    }

    getPaymentSecret() {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return this.http.get<{ client_secret: string }>(`${environment.apiUrl}/card-payment/secret`);
    }

    getPublicAccessToken(deviceId: string) {
        return this.http.post<{ accessToken: string }>(`${this.path}/user/auth/get-public-token`, { deviceId });
    }

    getUserProfile() {
        return this.http.get<User>(`${this.path}/user/profile`);
    }

    addUserProfileAddress(payload: any) {
        if (payload?.id) {
            return this.http.put<any>(`${this.path}/user/address`, payload);
        }
        return this.http.post<any>(`${this.path}/user/address`, payload);
    }

    removeUserProfileAddress(payload: any) {
        return this.http.delete<any>(`${this.path}/user/address/${payload?.id}`);
    }

    getMyOrders(payload: IPagination) {
        return this.http.post<IPaginateResult<Order>>(`${this.path}/order/get-all-my-orders`, payload);
    }

    getMyCoupons() {
        return this.http.get<Coupon[]>(`${this.path}/order/coupons`);
    }

    deleteAccount() {
        return this.http.delete(`${this.path}/auth/delete-account`);
    }

    requestAccountData() {
        return this.http.get(`${this.path}/user/request-data`);
    }

    initChangePassword(body: InitChangePassword) {
        return this.http.post(`${this.path}/user/auth/init-change-password`, body);
    }

    changePassword(body: ChangePassword) {
        return this.http.post<{ success: boolean }>(`${this.path}/user/auth/change-password`, body);
    }

    refreshToken(payload: string) {
        return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.path}/auth/refresh`, payload);
    }
}
